import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/admin/ausstattung")({
  component: EquipmentLayout,
});

function EquipmentLayout() {
  return <Outlet />;
}